import {useQuery} from "@tanstack/react-query"
import {useSelector, useDispatch} from "react-redux"

import {useApiDefaults} from "./useApiDefaults"
import axios from "config/axios"
import { fetchcouponCartListSuccess } from 'redux/actions'
import { refetchOnWindowFocus } from 'config/reactQuery'

export function useGetCouponsCartDetails(enabled = true) {
  const apiDefaults = useApiDefaults()
  const isUserLoggedIn = useSelector(({user}) => user?.isUserLoggedIn)
  const dispatch = useDispatch()

  async function getDat() {
    if (!isUserLoggedIn) {
      return []
    }

    const res = await axios.post("/AogGetMyCouponsCartDetails", apiDefaults)
    const data = res?.data?.data?.MyCartInfo ?? []
    dispatch(fetchcouponCartListSuccess(data))
    return data
  }

  const {data, isLoading, error, refetch} = useQuery({
    queryKey: ["coupons-cart-details", apiDefaults, isUserLoggedIn],
    queryFn: getDat,
    enabled,
    refetchOnWindowFocus,
  })

  return {data, isLoading, error, refetch}
}
